import { useEffect } from 'react';

/**
 * ドキュメントのタイトルを設定するカスタムフック。
 *
 * @param {string} title - 設定するドキュメントのタイトル
 */
export default function useDocumentTitle(title: string) {
  useEffect(() => {
    document.title = title;
  }, [title]);
}